import { useIntl } from 'react-intl';

import * as S from './styles';
import { useIntlContext } from '../../i18n';
import { CONFIG } from '../../consts/prices';

// Rendered only when mostrarSeletorDeIdioma is on in src/consts/prices.js.
function LanguageSwitcher() {
  const { locale, switchLanguage } = useIntlContext();
  const intl = useIntl();

  if (!CONFIG.mostrarSeletorDeIdioma) return null;

  return (
    <S.Switcher>
      {['pt', 'en'].map((code) => (
        <button
          key={code}
          type="button"
          onClick={() => switchLanguage(code)}
          aria-label={intl.formatMessage({ id: `lang.${code}` })}
          aria-current={locale === code}
          className={locale === code ? 'active' : undefined}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </S.Switcher>
  );
}

export default LanguageSwitcher;
